/**
 * Owner Access Hook
 *
 * Checks if current user is the app owner.
 * Used to restrict access to /dev and /log pages.
 */

import { useAuth } from '../services/auth';

// Owner email - primary owner with full access
const OWNER_EMAIL = 'nova223@gmail.com';

// Dev emails - users who can access dev pages (/dev, /log)
const DEV_EMAILS = new Set([
  OWNER_EMAIL,
  'teslax707@gmail.com',
]);

export interface OwnerAccessState {
  isOwner: boolean;
  isLoading: boolean;
  userEmail: string | null;
}

/**
 * Check if current authenticated user is the owner.
 *
 * @returns { isOwner, isLoading, userEmail }
 */
export function useOwnerAccess(): OwnerAccessState {
  const { user, isLoading } = useAuth();
  const email = user?.email?.toLowerCase() ?? null;

  return {
    isOwner: email ? DEV_EMAILS.has(email) : false,
    isLoading,
    userEmail: email,
  };
}

/**
 * Get owner email constant (for display purposes)
 */
export function getOwnerEmail(): string {
  return OWNER_EMAIL;
}

export default useOwnerAccess;
